import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import DotTrigger from '../../../../components/global/DotTrigger';
import { sideNavToggle } from '../../redux/layout/layoutActions';

const propTypes = {
  className: PropTypes.string,
};

const ContentSideNavTrigger = ({ className }) => {
  const { sideNavExpanded } = useSelector(state => state.pro.layout);
  const dispatch = useDispatch();
  const onSideNavToggle = useCallback(() => dispatch(sideNavToggle()), [
    dispatch,
  ]);
  const classes = classNames({
    // Only visible on mobile
    'd-lg-none': true,
    [className]: !!className,
  });

  return (
    <DotTrigger
      className={classes}
      active={sideNavExpanded}
      onClick={onSideNavToggle}
    />
  );
};

ContentSideNavTrigger.propTypes = propTypes;

export default ContentSideNavTrigger;
